<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>USTED ESTA AQUI</b-breadcrumb-item>
      <b-breadcrumb-item active>CDC</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="page-title">Cuadro de Cumplimiento GRUPO AVANSA</h1>

  <!--
    <b-row>
      <b-col xs="12">
    
          <div class="table-responsive">
            
            <vx-card title="Accordion" code-toggler>
          

            <div class="mt-5">

                <vs-collapse accordion>

                    <vs-collapse-item >

                        <div slot="header"><span class='fw-semi-bold ml-xs'>PRESENTACION PERSONAL</span><span class="fw-normal ml-lg mb-lg">5 puntos</span> </div>
                        <vs-divider/>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque rhoncus eros tortor, non fringilla lectus cursus et. Fusce vel nisi ante. Aliquam sit amet lectus pharetra, luctus mi sed, aliquet felis. Mauris a tortor viverra, ornare tellus in, consectetur leo.
                        
                        Etiam nec nunc nec nisl luctus tincidunt efficitur vitae elit. Vestibulum iaculis nibh commodo neque ultrices lobortis. Cras magna massa, pretium vitae mattis varius, pharetra nec massa. Aliquam ac ex enim. Quisque consequat dui libero, vel blandit lorem porttitor sit amet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nullam sed lobortis nisl, quis eleifend metus.
                    </vs-collapse-item>

                    <vs-collapse-item>

                        <div slot="header">Collapse item 2</div>

                        Nunc auctor et leo vitae suscipit. Nullam aliquet purus scelerisque enim hendrerit tristique. Maecenas tincidunt dui arcu, a aliquet nisl venenatis vitae. Praesent mauris ligula, porta at maximus ac, rutrum vitae sapien. Donec a sapien id erat dapibus dignissim sodales in est. Donec gravida dapibus sapien at sollicitudin. Maecenas iaculis quam ex,
                        <br><br>
                        eu aliquam erat sagittis eget. Suspendisse mollis felis nec ipsum vehicula, at posuere libero viverra. Nam hendrerit dapibus eleifend. Aliquam elit nulla, tincidunt pellentesque enim mollis, consectetur placerat enim. Integer condimentum tristique ante et ullamcorper. Mauris placerat pretium ex. Nam aliquam sed tortor sit amet
                        <br><br>
                        efficitur. Mauris quis faucibus nulla. Pellentesque egestas non ipsum vel maximus.
                    </vs-collapse-item>

                    <vs-collapse-item disabled>

                        <div slot="header">Collapse item 3 - Disabled</div>

                        Suspendisse aliquet condimentum diam, sed aliquam nisl dapibus et. Aliquam euismod ullamcorper dolor eu
                    </vs-collapse-item>

                    <vs-collapse-item>

                        <div slot="header">Collapse item 4</div>

                        Suspendisse aliquet condimentum diam, sed aliquam nisl dapibus et. Aliquam euismod ullamcorper dolor eu imperdiet. Nullam eget odio at magna gravida suscipit sed vestibulum odio. Maecenas porta elit vel lectus molestie, eget aliquam enim feugiat. Vivamus nec faucibus nisl. Nunc venenatis tempus finibus.
                    </vs-collapse-item>
                </vs-collapse>

            </div>

            </vx-card>

          </div>
      
      </b-col>
    </b-row>
-->

    <p><b-button
            variant="success" id="show-success-message" @click="openNewCDC"
          >Nuevo CDC</b-button></p>

    <b-row>
      <b-col lg="4" sm="6" xs="12">
        <Widget
          title="<h5 class='d-flex align-items-center pb-1'>
            <span class='circle bg-primary mr-sm' style='font-size: 6px;'></span>
            <span class='fw-normal ml-xs'>PRESENTACION PERSONAL</span>
          </h4>"
          bodyClass="p-0 mt"
          customHeader>
          <h4 class="fw-semi-bold ml-lg mb-lg">5 <small> puntos (ponderado)</small></h4>
          <vs-divider/>
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Uniforme, Cabello profesional, Uso de gafete, maquillage en damas sin exceso, bogote corte profesional y pequeño.</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div>  
        </Widget>
      </b-col>

       <b-col lg="4" sm="6" xs="12">
        <Widget
          title="<h5 class='d-flex align-items-center pb-1'>
            <span class='circle bg-primary mr-sm' style='font-size: 6px;'></span>
            <span class='fw-normal ml-xs'>BIENVENIDA</span>
          </h4>"
          bodyClass="p-0 mt"
          customHeader>
          <h4 class="fw-semi-bold ml-lg mb-lg">10 <small> puntos (ponderado)</small></h4>
          <vs-divider/>
          <div class=" border-right p-3 px-4">
            <p >
              <small>Buenos dias/tarde/noche Bienvenido a Promerica</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div>  
          <div class=" border-right p-3 px-4">
            <p >
              <small>Mi nombre es ¿Cómo puedo apoyarle, servirle, etc.</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div> 
        </Widget>
      </b-col>

       <b-col lg="4" sm="6" xs="12">
        <Widget
          title="<h5 class='d-flex align-items-center pb-1'>
            <span class='circle bg-primary mr-sm' style='font-size: 6px;'></span>
            <span class='fw-normal ml-xs'>PERSONALIZACION</span>
          </h4>"
          bodyClass="p-0 mt"
          customHeader>
          <h4 class="fw-semi-bold ml-lg mb-lg">35 <small> puntos (ponderado)</small></h4>
          <vs-divider/>
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Mencionar el nombre del representante (desde Bienvenida)</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div>
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Llamar al cliente por su nombre o apellido en 3 ocaciones como mínimo.</small>
            </p>
            <h5>30 puntos</h5>
              <vs-divider/>
          </div>
        </Widget>
      </b-col>

      <b-col lg="4" sm="6" xs="12">
        <Widget
          title="<h5 class='d-flex align-items-center pb-1'>
            <span class='circle bg-primary mr-sm' style='font-size: 6px;'></span>
            <span class='fw-normal ml-xs'>IMPULSO COMERCIAL</span>
          </h4>"
          bodyClass="p-0 mt"
          customHeader>
          <h4 class="fw-semi-bold ml-lg mb-lg">20 <small> puntos (ponderado)</small></h4>
          <vs-divider/>
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Ofrecer cualquier producto o servicio adicional a los que el cliente posee, ya sea un trifoliar, unifoliar o verbalmente.</small>
            </p>
            <h5>20 puntos</h5>
              <vs-divider/>
          </div>  
        </Widget>
      </b-col>

       <b-col lg="4" sm="6" xs="12">
        <Widget
          title="<h5 class='d-flex align-items-center pb-1'>
            <span class='circle bg-primary mr-sm' style='font-size: 6px;'></span>
            <span class='fw-normal ml-xs'>ESTANDARES DE SERVICIO AL CLIENTE</span>
          </h4>"
          bodyClass="p-0 mt"
          customHeader>
          <h4 class="fw-semi-bold ml-lg mb-lg">20 <small> puntos (ponderado)</small></h4>
          <vs-divider/>
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Contacto Visual (mirada del ejecutivo, a la mirada del cliente).</small>
            </p>
            <h5>10 puntos</h5>
              <vs-divider/>
          </div>  
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Sonrisa Amigable.</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div>  
           <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Habitos de cortesia( por favor, disculpe, con mucho gusto, gracias, etc).</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div> 
        </Widget>
      </b-col>
  
      <b-col lg="4" sm="6" xs="12">
        <Widget
          title="<h5 class='d-flex align-items-center pb-1'>
            <span class='circle bg-primary mr-sm' style='font-size: 6px;'></span>
            <span class='fw-normal ml-xs'>CIERRE</span>
          </h4>"
          bodyClass="p-0 mt"
          customHeader>
          <h4 class="fw-semi-bold ml-lg mb-lg">10 <small> puntos (ponderado)</small></h4>
          <vs-divider/>
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Sr, Srta, Sra ¿le puedo ayudar en algo más?</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div>  
          <div class=" border-right p-3 px-4">
            <p class="text-muted mb-0 mr">
              <small>Fue un gusto atenderle esperemos su visita nuevamente.</small>
            </p>
            <h5>5 puntos</h5>
              <vs-divider/>
          </div>  
        </Widget>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import $ from 'jquery';
/* eslint-disable */
import 'imports-loader?jQuery=jquery,this=>window!flot';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie';
/* eslint-enable */
import Widget from '@/components/Widget/Widget';

export default {
  name: 'Dashboard',
  components: { Widget },
  data() {
    return {
      table: [{
        id: 0,
        name: 'Mark Otto',
        email: 'ottoto@wxample.com',
        product: 'ON the Road',
        price: '$25 224.2',
        date: '11 May 2017',
        city: 'Otsego',
        status: 'Sent',
      },
      {
        id: 1,
        name: 'Jacob Thornton',
        email: 'thornton@wxample.com',
        product: 'HP Core i7',
        price: '$1 254.2',
        date: '4 Jun 2017',
        city: 'Fivepointville',
        status: 'Sent',
      },
      {
        id: 2,
        name: 'Larry the Bird',
        email: 'bird@wxample.com',
        product: 'Air Pro',
        price: '$1 570.0',
        date: '27 Aug 2017',
        city: 'Leadville North',
        status: 'Pending',
      },
      {
        id: 3,
        name: 'Joseph May',
        email: 'josephmay@wxample.com',
        product: 'Version Control',
        price: '$5 224.5',
        date: '19 Feb 2018',
        city: 'Seaforth',
        status: 'Declined',
      },
      {
        id: 4,
        name: 'Peter Horadnia',
        email: 'horadnia@wxample.com',
        product: 'Let\'s Dance',
        price: '$43 594.7',
        date: '1 Mar 2018',
        city: 'Hanoverton',
        status: 'Sent',
      }],
    };
  },
  methods: {
  openNewCDC() {
      this.$router.push('/app/newCDC');
    },

    getRandomData() {
      const arr = [];

      for (let i = 0; i < 25; i += 1) {
        arr.push(Math.random().toFixed(1) * 10);
      }

      return arr;
    },
    getData() {
      const data = [];
      const seriesCount = 3;
      const accessories = ['SMX', 'Direct', 'Networks'];

      for (let i = 0; i < seriesCount; i += 1) {
        data.push({
          label: accessories[i],
          data: Math.floor(Math.random() * 100) + 1,
        });
      }

      return data;
    },
    initChart() {
      $.plot(this.$refs.chartContainer, this.getData(), {
        series: {
          pie: {
            innerRadius: 0.8,
            show: true,
            fill: 0.5,
          },
        },
        colors: ['#ffc247', '#f55d5d', '#9964e3'],
        legend: {
          noColumns: 1,
          container: this.$refs.chartLegend,
          labelBoxBorderColor: '#ffffff',
        },
      });
    },
  },
  mounted() {
    this.initChart();

    window.addEventListener('resize', this.initChart);
  },
};
</script>

<style src="./Dashboard.scss" lang="scss" scoped />
